<template>
  <div>
    <div class="text-center">Telemetry</div>
    <div class="font-mono bg-black text-white mt-2 rounded-lg p-2 overflow-auto max-h-64">
      <p class="">CurrentLocation:</p>
      <div class="py-2 text-sm">
        {{ location }}
      </div>
    </div>
    <div class="font-mono bg-black text-white mt-2 rounded-lg p-2 relative overflow-auto max-h-64">
      <button @click="getLocation" class="sticky top-0 right-0 float-right text-sm text-black bg-white px-2">
        @Refetch
      </button>
      <span class="sticky top-0 left-0 bg-black">LocalLocations:</span>
      <div class="py-2 text-sm">
        {{ localLoca }}
      </div>
    </div>
    <div class="font-mono bg-black text-white mt-2 rounded-lg p-2 relative overflow-auto max-h-64">
      <button @click="getLocalStorage" class="sticky top-0 right-0 float-right text-sm text-black bg-white px-2">
        @Refetch
      </button>
      <span class="sticky top-0 left-0 bg-black">LocalStorage:</span>
      <div class="py-2 text-sm">
        {{ localData }}
      </div>
    </div>
    <div class="font-mono bg-black text-white mt-2 rounded-lg p-2 relative overflow-auto max-h-64">
      <span class="sticky top-0 left-0 bg-black">Logging:</span>
      <div class="py-2 text-sm">
        <template v-for="(item, i) in log.data">
          <p :key="i">
            <span class="text-gray-400">[{{ item.type }}]</span>
            {{ item.message }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { location, getLocalLocations } from "@/states/location";
  import { log } from "@/states/log";
  export default {
    data() {
      return {
        location,
        localLoca: getLocalLocations(),
        localData: window.localStorage,
        log
      };
    },
    methods: {
      getLocation() {
        this.localLoca = getLocalLocations();
      },
      getLocalStorage() {
        let store = {};
        for (let i = 0; i < localStorage.length; i++) {
          let key = localStorage.key(i);
          store[key] = this.truncate(localStorage.getItem(key));
        }
        this.localData = store;
      },
      truncate(str) {
        if (str.length > 50) {
          return str.substring(0, 50) + "...";
        }
        return str;
      }
    }
  };
</script>
